<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 text-primary"><i class="fas fa-calendar text-primary"></i> Class Timetable</h5>
      </div>
      <hr />
      <div class="row g-3">
      <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class="col-md-3">
          <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3 text-md-start text-end mt-md-5 mt-2">
          <button class="btn btn-sm btn-success me-1" @click="save()">
            <i class="fa fa-search text-white"></i> Go
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Clear</button>
        </div>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="col-md-12 text-end" v-if="showMessage">
        <a class="text-primary me-1 text-decoration-underline cursor-pointer" role="button" data-bs-toggle="modal"
          data-bs-target="#ClassTimetableDetailsModal">
          View All
        </a>
      </div>
      <div class="row"  v-if="showTimeTable">
        <div class="col-md-12 table-responsive mt-2">
             <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <table class="table  table-bordered custom-table" v-if="progress==0">
            <thead>
              <tr>
                <th>Day</th>
                <th>Subject</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Teacher</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in List" :key="index">
                <td>{{ item.Day }}</td>
                <td>{{ item.Subject }}</td>
                <td>{{ formatDateTime(item.StartTime) }}</td>
                <td>{{ formatDateTime(item.EndTime) }}</td>
                <td>{{ Teachers.find(t => t._id === item.Teacher)?.Name || "-" }}</td>

                <td>
                  <i class="fa fa-trash text-danger fs-5 mt-1 cursor-pointer" data-bs-toggle="modal"
                    data-bs-target="#standard-modal"  role="button" @click="delID = item"> </i>
                </td>
              </tr>
              <tr v-if="showInput">
                <td>
                  <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="TimeObj.Day">
                    <option selected disabled value="">Select Day</option>
                    <option v-for="(day, i) in days" :key="i" :value="day">{{ day }}</option>
                  </select>
                </td>
                <td>
                  <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="TimeObj.Subject">
                    <option selected=""></option>
                    <option v-for="(item, index) in filteredSubjects" :key="index" :value="item.name">
                      {{ item.name }}
                    </option>
                  </select>
                </td>
                <td> <input class="form-control form-control-sm cursor-pointer" role="button" type="time" id="example-time" name="time"  v-model="TimeObj.StartTime"> </td>
                <td> <input class="form-control form-control-sm cursor-pointer" role="button" type="time" id="example-time" name="time"  v-model="TimeObj.EndTime"> </td>
                <td>
                  <div class="dropdown dropup w-100" data-bs-display="static">
                  <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    {{ Teachers.find(sub => sub._id === TimeObj.Teacher)?.Name || " " }}
                  </button>

                  <ul class="dropdown-menu w-100 scrollable-menu ">
                    <li v-for="(item, index) in Teachers" :key="'item-' + index">
                      <a class="dropdown-item" href="#" @click.prevent="TimeObj.Teacher = item._id" >
                        {{ item.Name }}
                      </a>
                    </li>
                  </ul>
                </div>
                </td>
                <td> <i class="fa fa-save text-primary fs-4 mt-2 cursor-pointer" role="button" @click="addRow"></i> </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal fade" id="ClassTimetableDetailsModal" tabindex="-1" aria-labelledby="ClassTimetableDetailsModal"
      aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-bordered text-center custom-table">
                <tbody style="padding:0px 5px;">
                  <tr v-for="(entries, day) in groupedByDay" :key="day">
                    <th style="writing-mode: vertical-rl; transform: rotate(180deg); width:10px; text-align: center; color:#12a0a7;">
                      {{ day }}
                    </th>
                    <td v-for="i in maxPeriods" :key="i">
                      <div v-if="entries[i - 1]" class="text-start">
                        <p class="mb-1 text-info fs-11">{{ formatDateTime(entries[i - 1].StartTime) }} - {{ formatDateTime(entries[i - 1].EndTime) }}</p>
                        <h6 class="mb-1 text-success">{{ entries[i - 1].Subject }}</h6>
                        <p class="text-warning">{{ Teachers.find(sub => sub._id ===  entries[i - 1].Teacher)?.Name || " " }}</p>
                      </div>
                      <div v-else>-</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DelPopup :name="clsList.find(cls => cls._id == delID.clsID)?.name" @delRecord="delRecord" @closeModal="delID={}" />
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { api } from '@/utils/helpers.js';
import { ref, onMounted, computed } from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList,  subList } = schoolStore();
const Obj =ref({ _id: "", clsID: "", sectionID: "" })
const TimeObj =ref( { Day: "", Subject: "", StartTime: "", EndTime: "", Teacher: "", })
const List = ref([])
const Teachers = ref([])
const msgObj = ref({ msg: "", role: "", show: false })
const delID = ref({})
const errors = ref({})
const showInput = ref(false)
const showTimeTable= ref(false)
const days = ref(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"])
const showMessage = ref(false)
const filteredSubjects = computed(() => {
  if (!Obj.value.clsID) return [];
  return subList.value.filter(s => s.clsID === Obj.value.clsID);
});
const groupedByDay = computed(() => {
  const grouped = {};
  for (const entry of List.value) {
    if (!grouped[entry.Day]) grouped[entry.Day] = [];
    grouped[entry.Day].push(entry);
  }
  for (const day in grouped) {
    grouped[day].sort((a, b) => {
      const parseTime = (t) => {
        const [time, period] = t.split(" ");
        let [hour, minute] = time.split(":").map(Number);
        if (period === "PM" && hour !== 12) hour += 12;
        if (period === "AM" && hour === 12) hour = 0;
        return hour * 60 + minute;
      };
      return parseTime(a.StartTime) - parseTime(b.StartTime);
    });
  }
  const orderedGrouped = {};
  for (const day of days.value) {
    if (grouped[day]) orderedGrouped[day] = grouped[day];
  }
  return orderedGrouped;
})
 const formatDateTime= (timeStr) => {
  if (!timeStr) return "";
  let [hours, minutes] = timeStr.split(":").map(Number);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
};
const maxPeriods = computed(() => {
  return Math.max(...Object.values(groupedByDay.value).map(dayList => dayList.length));
})
 const loadTeachers= async() => {
      try {
        const res = await api.get(`/teachers/all`);
        Teachers.value = res.data;  
      }
      catch (err) { console.error("Failed to load Teachers", err); }
    }
 const addRow = async () => {
  const { Day, Subject, StartTime, EndTime, Teacher } = TimeObj.value;
  if (Day && Subject && StartTime && EndTime && Teacher) {
  const toMinutes = (time) => {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};

const newStart = toMinutes(StartTime);
const newEnd = toMinutes(EndTime);

const isDuplicate = List.value.some(item => {
  if (item.Day !== Day || item.clsID !== Obj.value.clsID || item.sectionID !== Obj.value.sectionID) return false;
  const existingStart = toMinutes(item.StartTime);
  const existingEnd = toMinutes(item.EndTime);
  return (newStart < existingEnd && newEnd > existingStart); 
});


    if (isDuplicate) {
      msgObj.value = { msg: "Class Timetable Already Exists", role: "danger", show: true, };
      return; 
    }
    try {
      await api.post(`/clsTimeTbl/add`, { ...Obj.value, ...TimeObj.value });
      msgObj.value = { msg: "ClassTimeTable Added Successfully", role: "success", show: true, };
      loadData();
    } catch (error) {
      console.error(error);
    }
    TimeObj.value = { Day: "", Subject: "", StartTime: "", EndTime: "", Teacher: "" };
  } else {
    alert("Please fill all fields before adding.");
  }
};

     const save = async() => {
      const fields = {
        Class: { value: Obj.value.clsID, validators: [isRequired] },
        Section: { value: Obj.value.sectionID, validators: [isRequired] },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        await loadData();
        showInput.value = true;
        showMessage.value = true;
        showTimeTable.value= true;
      }
    }
    const reset = async() => {
      Obj.value={ clsID: "", sectionID: "" };
      TimeObj.value = { Day: "", Subject: "", StartTime: "", EndTime: "", Teacher: "", };
      errors.value={};
      showMessage.value = false;
      showTimeTable.value= false;
    }
     const progress = ref(0)
     const loadData= async() => {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      const params = new URLSearchParams();
      if (Obj.value.clsID) { params.append("clsID", Obj.value.clsID); }
      if (Obj.value.sectionID) { params.append("sectionID", Obj.value.sectionID); }
      await api.get(`/clsTimeTbl/all?${params.toString()}`).then((response) => { List.value = response.data;
          progress.value = 0
          clearInterval(progressInterval)  });
    }
     const delRecord = async() => {
      if (!delID.value._id) return;
      try {
        await api.delete(`/clsTimeTbl/${delID.value._id}`);
        msgObj.value = { msg: "ClassTimeTable Deleted Successfully.", role: "danger", show: true, };
        loadData();
      }
      catch (error) { console.error("Error deleting timetable record:", error); }
      finally { delID.value = {}; }
    }
     onMounted(() => { loadData(); loadTeachers(); })
</script>
<style>
.table-responsive, .card-body, .row {
  overflow: visible !important;
}
 .custom-table th, .custom-table td, .custom-table {
    border: 1px solid #c1baba87 !important;
    border-collapse: collapse;
  }
  #ClassTimetableDetailsModal{
      background-color: rgb(12 12 12 / 50%);
      z-index:9999;
  }
  @media (max-width: 375px) {
.fs-11{font-size:11px;}
}
</style>
